@if (rating != null) { @for (i of range; track i) {
<icon [class.highlighted]="normalizedRating >= i" type="star-fill"></icon>
} } @if (rating == null) {
<empty>Unknown</empty>
}
